// extracted by mini-css-extract-plugin
export var cancelButton = "_ny-5";
export var content = "_ny-3";
export var createButton = "_ny-6";
export var drawerContainer = "_ny-0";
export var footer = "_ny-2";
export var header = "_ny-1";
export var orderFormColumn = "_ny-4";